import alt from 'components/Dispatcher';
import LocationActions from 'actions/LocationActions';
import LocationSource from 'sources/LocationSource';

export class LocationStore {
  constructor() {
    this.state = {
      location_id: '', // 当前选中地址id,供分享回流使用
      type: '', // 当前选中地址type，供分享回流使用
      location: null, // 当前选中的地址
      first: 0,
      maxCount: 8,  //每次获取 8 个，只用前7个，可判断是否还有更多
      locations: [], // 当前可选的地址列表
      continent: null, // 当前选中的洲
      country: null, // 当前选中的国家
      state: null, // 当前选中的省
      city: null,  // 当前选中的城市
      needRefresh: false
    };
    this.registerAsync(LocationSource);
    this.bindListeners({
      handleFetchLocationList: LocationActions.FETCH_LOCATION_LIST,
      handleUpdateLocationList: LocationActions.UPDATE_LOCATION_LIST,
      handleFetchAllLocationList: LocationActions.FETCH_ALL_LOCATION_LIST,
      handleUpdateMoreLocationList: LocationActions.UPDATE_MORE_LOCATION_LIST,
      handleUpdateLocation: LocationActions.UPDATE_LOCATION,
      handleUpdateLocations: LocationActions.UPDATE_LOCATIONS,
      handleUpdateContinent: LocationActions.UPDATE_CONTINENT,
      handleUpdateCountry: LocationActions.UPDATE_COUNTRY,
      handleUpdateState: LocationActions.UPDATE_STATE,
      handleUpdateCity: LocationActions.UPDATE_CITY,
      handleFetchLocation: LocationActions.FETCH_LOCATION,
      handleUpdateRefreshTag: LocationActions.UPDATE_REFRESH_TAG
    });
  }
  handleUpdateRefreshTag(refresh){
    this.setState({needRefresh: refresh === '1'})
  }
  handleFetchLocationList(location) {
    this.setState({location: location, first: 0});
    this.getInstance().getRemoteLocation();
  }
  handleFetchAllLocationList() {
    this.getInstance().getAllRemoteLocation();
  }
  handleUpdateLocationList(locationList) {
    this.setState({locations: locationList});
  }
  handleUpdateMoreLocationList(locationList) {
    this.state.locations.pop();
    let newLocationList = this.state.locations.concat(locationList)
    this.setState({locations: newLocationList});
  }
  handleUpdateLocations(locations){
    this.state.locations = locations;
  }
  handleUpdateLocation(location) {
    let newState = {};
    let continent, country, state;
    switch(location.type) {
      case 'world':
        newState = {
          location: location,
          continent: null, // 当前选中的洲
          country: null, // 当前选中的国家
          state: null, // 当前选中的省
          city: null  // 当前选中的城市
        };
        break;
      case 'continent':
        newState = {
          location: location,
          continent: location, // 当前选中的洲
          country: null, // 当前选中的国家
          state: null, // 当前选中的省
          city: null  // 当前选中的城市
        };
        break;
      case 'country':
        continent = location.continent?location.continent:this.state.continent;
        if(!continent.type) continent.type = 'continent';
        newState = {
          location: location,
          continent: continent,
          country: location, // 当前选中的国家
          state: null, // 当前选中的省
          city: null  // 当前选中的城市
        };
        break;
      case 'state':
        continent = location.continent?location.continent:this.state.continent; 
        country = location.country?location.country:this.state.country;
        if(!continent.type) continent.type = 'continent';
        if(!country.type) country.type = 'country';
        newState = {
          location: location,
          continent: continent,
          country: country,
          state: location, // 当前选中的省
          city: null  // 当前选中的城市
        }
        break;
      case 'city': {
        continent = location.continent?location.continent:this.state.continent; 
        country = location.country?location.country:this.state.country;
        if(!continent.type) continent.type = 'continent';
        if(!country.type) country.type = 'country';
        state = location.state?location.state:this.state.state;
        if(!state.type) country.type = 'state';
        if(!state._id) state._id = location.state_id;
        newState = {
          location: location,
          continent: continent,
          country: country,
          state: state,
          city: location
        };
      }
      default:
        break;
    }
    this.setState(newState);
  }
  handleFetchLocation(location){
    this.setState({
      type: location.type,
      location_id: location.id
    });
    this.getInstance().getLocation();
  }
  handleUpdateContinent(continent) {
    if(continent){
      continent.type = 'continent';
    }
    this.setState({continent: continent});
  }
  handleUpdateCountry(country) {
    if(country){
      country.type = 'country';
    }
    this.setState({country: country});
  }
  handleUpdateState(state) {
    if(state){
      state.type = 'state';
    }
    this.setState({state: state});
  }
  handleUpdateCity(city) {
    if(city){
      city.type = 'city';
    }
    this.setState({city: city});
  }
}

export default alt.createStore(LocationStore, 'LocationStore');



// WEBPACK FOOTER //
// ./src/stores/LocationStore.js